import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <main
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: "'Nunito', sans-serif",
            background: 'var(--parchment, #FDF6EC)',
            color: 'var(--ink, #3B2F20)',
            textAlign: 'center',
            padding: '2rem',
          }}
        >
          <div style={{ maxWidth: 480 }}>
            <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>
              Oops! Something went wrong
            </h1>
            <p style={{ color: 'var(--text-muted, #7A7064)', marginBottom: '1.5rem' }}>
              Our little fox got tangled in the story. Don't worry — your work is safe.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                padding: '0.75rem 2rem',
                fontSize: '1rem',
                fontWeight: 600,
                fontFamily: "'Nunito', sans-serif",
                background: 'var(--deep-teal, #2A7A6E)',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            >
              Go back home
            </button>
            {process.env.NODE_ENV !== 'production' && this.state.error && (
              <pre
                style={{
                  marginTop: '2rem',
                  padding: '1rem',
                  background: 'rgba(0,0,0,0.05)',
                  borderRadius: '8px',
                  fontSize: '0.75rem',
                  textAlign: 'left',
                  overflow: 'auto',
                  maxHeight: 200,
                }}
              >
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
